var NAVIGATOR_PANE = "_navigator";
var NAVIGATOR_AXIS = NAVIGATOR_PANE;
var DEFAULT_PANE = "_default";

export { NAVIGATOR_AXIS, NAVIGATOR_PANE, DEFAULT_PANE };
